var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.7468 9.61516L12.6808 14.3964C12.4356 14.6277 12.0761 14.6908 11.7667 14.5579C11.4573 14.4244 11.2566 14.1195 11.2566 13.7827L11.2534 11.2831L6.75339 11.2831C6.13147 11.2831 5.62769 10.7793 5.62769 10.1581V7.90808C5.62769 7.28687 6.13183 6.78308 6.75339 6.78308L11.2534 6.78311L11.2566 4.25186C11.2566 3.91514 11.4573 3.61026 11.7667 3.47667C12.0762 3.34374 12.4358 3.40692 12.6808 3.63818L17.7468 8.41943C18.0843 8.70461 18.0843 9.29524 17.7468 9.61516Z",
    fill: "#718096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.375 16.875H5.625C6.24727 16.875 6.75 16.3723 6.75 15.75C6.75 15.1277 6.24727 14.625 5.625 14.625H3.375C2.75379 14.625 2.25 14.1212 2.25 13.5V4.5C2.25 3.87879 2.75379 3.375 3.375 3.375H5.625C6.24727 3.375 6.75 2.87121 6.75 2.25C6.75 1.62879 6.24727 1.125 5.625 1.125H3.375C1.51102 1.125 0 2.63602 0 4.5V13.5C0 15.3633 1.51102 16.875 3.375 16.875Z",
    fill: "#718096"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutMobile);
export default __webpack_public_path__ + "static/media/logout-mobile.16e105cfbc533b538002037e41a50651.svg";
export { ForwardRef as ReactComponent };